import { API_LIST } from '@/const/api'
import { SYSCON } from '@/const/const'
import Axios from 'axios'

import { doEncrypt } from '@/utils/crypto-sm2.js'
import BaseModule from './baseModule'

class User extends BaseModule {
  userInfo = ''
  userTypeCd = ''
  prePhone = ''
  orgList = []
  prodList = null
  expenseProdList = null
  isLogin = false
  constructor() {
    super()
    if (typeof User.instance === 'object') {
      return User.instance
    } else {
      User.instance = this
      return this
    }
  }
  setUserInfo(info) {
    this.userInfo = info
  }
  setOrgList(list) {
    this.orgList = list
  }
  getOrgList() {
    return this.orgList
  }
  getUserInfo() {
    return this.userInfo
  }
  getProds() {
    return this.prodList
  }
  getExpenseProds() {
    return this.expenseProdList
  }
  getProdsByTitle(title) {
    return this.prodList && this.prodList.find(p => p.nm === title)
  }
  getExpendProdsByTitle(title) {
    return this.expenseProdList && this.expenseProdList.find(p => p.nm === title)
  }
  getUserName() {
    return this.userInfo.nm || this.userInfo.userNm || 'nobody'
  }
  getUserPhone() {
    return this.userInfo.phone
  }
  setUserName(nm) {
    this.userInfo.nm = nm || ''
  }
  setIsLogin(statu) {
    this.isLogin = statu
  }
  setUserTypeCd(cd) {
    this.userTypeCd = cd
  }
  getUserTypeCd() {
    return this.userTypeCd
  }

  getLoginStatu() {
    return localStorage.getItem(SYSCON.Token) && this.isLogin
  }
  _getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return JSON.parse(unescape(r[2]))
    return false
  }
  // 初始化登录
  async initUserInfo() {
    return new Promise(async(resovle, reject)=>{
      if (localStorage.getItem(SYSCON.Token)) {
        if (this._getQueryString('logoutFlag')) {
          this.loginOut()
          resovle()
        } else {
          const resultInfo = await this._getInfoByToken().catch((err)=>{
            this._catchHandler()
            reject(err)
          })
          if (!resultInfo) return

          await this._getOrgInfo().catch((err)=>{
            this._catchHandler()
            reject(err)
          })
          // if (!orgInfo) return
          if (this.orgList[0]) {
            await (this.orgList[0] && this._getInfoByOrgId(this.orgList[0].id).catch((err)=>{
              this._catchHandler()
              reject(err)
            }))
          }

          // if (!userInfo) return

          this.setIsLogin(true)
          resovle(true)
        }
      } else {
        this.setIsLogin(false)
        resovle(true)
      }
    })
  }
  _catchHandler() {
    this.setIsLogin(false)
  }
  _handleLoginOut() {
    return new Promise((resovle, reject) => {
      this.loginExit().then((res)=>{
        resovle(res)
      }).catch((err)=>{
        console.log('errrrr', err)
        reject(err)
      })
    })
  }
  async loginOut() {
    console.log('aaaaaa')
    return new Promise(async(resovle, reject) => {
      await this._handleLoginOut().catch(err => reject(err))
      localStorage.setItem(SYSCON.Token, '')
      this.setIsLogin(false)
      this.setUserInfo('')
      this.setOrgList([])
      resovle()
    })
  }
  async handleUserInfo(info) {
    localStorage.setItem(SYSCON.Token, info.token)

    this.setIsLogin(true)

    this.setUserInfo(info.userInfo)

    if (info.orgs && info.orgs.length > 0) {
      // 处理多组织用户
      this._handleMultiOrgUser(info.orgs[0].id)
    } else if (info.orgs && info.orgs.length === 0) {
      await this._getInfoByToken()
    } else {
      // 处理单组织用户
      this.setUserTypeCd(SYSCON.UserTypePersonal)
    }
  }
  async _handleMultiOrgUser(orgId) {
    await this._getInfoByOrgId(orgId)
    this._getOrgInfo()
  }
  _getInfoByToken() {
    return new Promise((resovle, reject) => {
      this.getUserByToken().then((res)=>{
        this.setUserInfo(res)
        resovle(res)
      }).catch((err)=>{
        console.log('errrrr', err)

        reject(err)
      })
    })
  }
  _getInfoByOrgId(orgId) {
    return new Promise((resovle, reject) => {
      const data = {
        orgId,
        appCatCd: SYSCON.PlatAppWorkbench
      }
      this.getInfo(data).then((res)=>{
        this.setUserInfo(res.userInfo)
        this._handleTypeCd(res.userInfo.apps)
        resovle(res)
      }).catch((err)=>{
        reject(err)
      })
    })
  }
  getUserInfoByOrgId(orgId, prodCd) {
    return new Promise((resovle, reject) => {
      const data = {
        orgId,
        appCatCd: prodCd
      }
      const headers = {
        appCatCd: prodCd
      }
      this.getInfo(data, headers).then((res)=>{
        resovle(res)
      }).catch((err)=>{
        reject(err)
      })
    })
  }
  _handleTypeCd(apps) {
    const appObj = JSON.parse(apps)
    const findApp = appObj.find((item) => item.appCatCd === SYSCON.PlatAppWorkbench)
    if (findApp) {
      this.setUserTypeCd(findApp.typeCd)
    }
  }
  _getOrgInfo() {
    return new Promise((resovle, reject) => {
      const params = {
        id: this.userInfo.id || this.userInfo.userId
      }
      this.getOrg(params).then((res)=>{
        this.setOrgList(res)
        resovle(res)
      }).catch((err)=>{
        reject(err)
      })
    })
  }

  getProductId(cd = SYSCON.PlatAppSmarterFin) {
    return new Promise((resovle, reject) => {
      this.getProductList().then((res)=>{
        let pid = ''
        const pObj = res.find((item) => item.cd === cd)
        pid = pObj && pObj.id
        resovle(pid)
      }).catch((err)=>{
        reject(err)
      })
    })
  }

  checkProductList(orgId, btnType) {
    return new Promise((resovle, reject) => {
      this.getProductDetail(orgId).then((res)=>{
        const proList = res.activatedList
        if (Array.isArray(proList)) {
          const findedProduct = proList.find((p) => p.prodNm === SYSCON.ProductNm)
          if (findedProduct && !findedProduct.tryFlag) {
            reject('已购买过该产品！')
          }
          if (btnType === SYSCON.BuyType) {
            if (!findedProduct || (findedProduct && findedProduct.tryFlag)) {
              resovle(true)
            }
          }
          if (btnType === SYSCON.TryType) {
            if (!findedProduct) {
              resovle(true)
            }
            if (findedProduct && findedProduct.tryFlag) {
              reject('已试用该产品！')
            }
          }
          if (findedProduct) {
            resovle(true)
          }
        }
      }).catch((err)=>{
        reject(err)
      })
    })
  }

  getProductList(params) {
    return this.get({ url: API_LIST.GET_PRODUCT_LIST, params }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  getProductDetail(rootOrgId) {
    const params = { rootOrgId }
    const config = {
      headers: {
        rootOrgId: ''
      }
    }
    return this.get({ url: API_LIST.GET_PRODUCT_DETAIL, params, config }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  getOrg(params) {
    return this.get({ url: API_LIST.GET_ORG_LIST, params }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  getInfo(query, headers) {
    return this.post({ url: API_LIST.GET_USERINFO, query, headers }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  getUserByToken() {
    return this.get({ url: API_LIST.GET_USER_BYTOEN }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  getRootOrgs() {
    return this._getOrgInfo().then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }

  onAppointment(data) {
    return this.post({ url: API_LIST.TRIAL_ADD, data }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  loginExit() {
    return this.post({ url: API_LIST.GET_USER_EXIT }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }

  login(data) {
    const params = {
      ...data,
      encryptFlg: true,
      password: doEncrypt(data.password)
    }
    return this.post({ url: API_LIST.USER_LOGIN, data: params }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  register(data, srcCd) {
    const params = {
      ...data,
      srcCd,
      encryptFlg: true,
      password: doEncrypt(data.password)
    }
    return this.post({ url: API_LIST.USER_REGISTER, data: params }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  findPwd(data) {
    const dto = {
      ...data,
      encryptFlg: true,
      pwd: doEncrypt(data.pwd)
    }
    return this.post({ url: API_LIST.FIND_PASSWORD, data: dto }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  checkPhone(params) {
    return this.get({ url: API_LIST.CHECK_PHONE, params }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  updUser(query) {
    return this.post({ url: API_LIST.UPD_USERINFO, query }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  updPwd(data) {
    const obj = {
      encryptFlg: true,
      newPwd: doEncrypt(data.newPwd),
      oldPwd: doEncrypt(data.oldPwd)
    }
    return this.post({ url: API_LIST.UPD_PWD, data: obj }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  sendCode(params) {
    return this.get({ url: API_LIST.GET_PHONE_CODE, params }).then((res) => {
      return res
    }).catch((err) => {
      throw err
    })
  }
  checkPurchaseQualification(userId, prodCd, smarterFinTradeEditionFlag = false) {
    const params = {
      userId,
      prodCd,
      smarterFinTradeEditionFlag
    }
    return this.get({
      url: API_LIST.CHECK_USER_PURCHASE_QUALIFICATION,
      params
    })
  }
  getProdList(cd) {
    return this.get({ url: API_LIST.GET_PROD_BYCATCD, params: { appCatCd: cd }}).then((res) => {
      if (cd === SYSCON.PlatAppExpense) {
        this.expenseProdList = res || []
      } else {
        this.prodList = res || []
      }
    }).catch((err) => {
      throw err
    })
  }
  getWxLoginQrCode() {
    return this.get({
      url: API_LIST.GET_WX_LOGIN_QR_CODE
    })
  }
  getQrScanRes({ appCatCd, scene }) {
    return this.get({
      url: API_LIST.GET_WX_Login_SCAN_RES,
      params: {
        appCatCd,
        scene
      }
    })
  }
  bindUserWechat(data) {
    return this.get({
      url: API_LIST.BIND_USER_WECHAT,
      params: data
    })
  }
  // 获取文章列表
  getArticleList(params) {
    console.log(params, 'paramsssss')
    return this.get({
      url: API_LIST.GET_ART_LIST,
      params
    })
  }
  // 获取文章详情
  getArticleID(id) {
    console.log(id, 'id')
    return this.get({
      url: API_LIST.GET_ART_DETAIL,
      query: {
        id
      }
    })
  }
  // 文章附件下载
  downloadAttach(docId, attachName) {
    const url = `${API_LIST.GET_ART_DOWNLOAD}?docId=${docId}&attachName=${attachName}`
    Axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/octet-stream'
      },
      url: url,
      responseType: 'arraybuffer'
    }).then(res => {
      console.log('ddd', res)
      const b = new Blob([res.data], { type: 'application/octet-stream' })
      const url = URL.createObjectURL(b)
      const link = document.createElement('a')
      // 设置导出的文件名
      link.download = attachName
      link.href = url
      // 点击获取文件
      link.click()
    })
  }
  // 获取视频中心列表
  // getSeasonsSeriesList(query) {
  //   return this.get({
  //     url: API_LIST.GET_SERIES_LISR,
  //     query
  //   })
  // }

  getAreaData(cd) {
    return this.get({
      url: API_LIST.GET_AREA_CODE,
      query: {
        cd
      }
    })
  }
}

export default User
